import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Contents from './Content';
import Header from './Header';
import Footer from './Footer';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles({
  box: {
    backgroundColor: '#f0f0f0',
    minHeight: '100vh'
  }
});

function Home(props) {
  const classes = useStyles();
  return (
    <Box className={classes.box}>
      <Header />
      {process.env.REACT_APP_STAGE === 'dev' || process.env.REACT_APP_STAGE === 'dev.local' || process.env.REACT_APP_STAGE === 'stg'
        ? props.token
        : ''}
      <Contents token={props.token} />
      <Footer />
    </Box>
  );
}

export default Home;
